// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__117pX","label":"Completed_label__2iL1u"};